import BasePage from '../../components/base-page/base-page';
import CategoryTabs from '../../components/category-tabs/category-tabs';
import BlogSearch from '../../components/search/search';

import './blog.scss';

class BlogPage extends BasePage {
  ui = {
    tabsContainer: '.js-tabs-container',
  };

  tabsContainerHiddenClass = 'blog-category-navigation__tabs-container_hidden';

  onInit() {
    super.onInit();
    new CategoryTabs().init();
    new BlogSearch({
      onOpen: this.hideTabsContainer,
      onClose: this.showTabsContainer,
    }).init();
  }

  hideTabsContainer = () => {
    this.ui.tabsContainer.classList.add(this.tabsContainerHiddenClass);
  };

  showTabsContainer = () => {
    this.ui.tabsContainer.classList.remove(this.tabsContainerHiddenClass);
  };
}

export default BlogPage;

BlogPage.initOnDomLoaded();
